import moment from 'moment-timezone';

import { ProductShape } from 'lib/util/productShape';
import { getPromotionTitleText } from 'lib/util/promotionTextHelpers';
import { WithTranslation } from 'react-i18next';
import { CurrencyFormatter } from 'hooks/useCurrencyFormatter';

export const getProductPageOgpTags = (
  product: ProductShape,
  showOgpHighlight: boolean,
  ogpPromotionId: string,
  headerText: string,
  supplierName: string,
  locale: string,
  t: WithTranslation['t'],
  currencyFormatter: CurrencyFormatter
): { [key: string]: string } => {
  const ogSiteName = `${headerText} ${supplierName}`;

  const firstImage = (product.mediaURLs || []).find((mediaItem) => {
    return mediaItem.type === 'IMAGE';
  });

  const ogImage = firstImage ? firstImage.url : '';

  let ogTitle = product?.name || '';

  let ogDescription = product?.description || '';

  let promotionSummary;
  if (ogpPromotionId) {
    promotionSummary = product.promotionSummaries.find((promotionSummary) => {
      return promotionSummary.id === ogpPromotionId;
    });
  }

  if (promotionSummary) {
    const promotionTitle =
      getPromotionTitleText(promotionSummary, t, locale, currencyFormatter) || '';
    ogTitle = [promotionTitle, ogTitle].join(' ');

    let participantDate = '';
    if (promotionSummary.startDateLocalFrom || promotionSummary.startDateLocalTo) {
      participantDate = t(
        'Participation Date: {{participationDateFrom}} ~ {{participationDateTo}}',
        {
          participationDateFrom: moment(promotionSummary.startDateLocalFrom)
            .locale(locale)
            .format('ll'),
          participationDateTo: moment(promotionSummary.startDateLocalTo)
            .locale(locale)
            .format('ll'),
        }
      );
    }
    let bookedDate = '';
    if (promotionSummary.bookedDateLocalFrom || promotionSummary.bookedDateLocalTo) {
      bookedDate = t('Booked Date: {{bookedDateFrom}} ~ {{bookedDateTo}}', {
        bookedDateFrom: moment(promotionSummary.bookedDateLocalFrom).locale(locale).format('ll'),
        bookedDateTo: moment(promotionSummary.bookedDateLocalTo).locale(locale).format('ll'),
      });
    }
    ogDescription = [participantDate, bookedDate, ogDescription].join(' ');
  } else {
    if (showOgpHighlight) {
      ogTitle = t('<Highlights>') + ' ' + ogTitle;
      const highlights = product.highlights
        .map((highlight, idx) => {
          return (
            t('Highlight #{{highlightNumber}}', { highlightNumber: idx + 1 }) + ' : ' + highlight
          );
        })
        .join(t(','));
      ogDescription = [highlights, ogDescription].join(' ');
    }
  }

  return {
    'og:title': ogTitle,
    'og:description': ogDescription,
    'og:site_name': ogSiteName,
    'og:image': ogImage,
  };
};
